import NavPayloadAction from '@carvana/merch-native/NavPayloadAction';
import { useContext } from 'react';
import { SELL_MY_CAR_URL } from '~/constants/common/sellMyCarUrl';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useConfiguration } from '~/context/common/StaticContext';
import ModalContext from '~/context/srp/ModalContext';
import useTradeCtaClick from '~/hooks/common/appraisal/useTradeCtaClick';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  position: number;
};

export default function TradeinTile({ position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const { setAppraisalEmbeddedModalOpen } = useContext(ModalContext);
  const { isEligible, onClick: handleTradeCtaClick } = useTradeCtaClick(
    isOpen => setAppraisalEmbeddedModalOpen(isOpen, 'srp-tile')
  );

  return (
    <ConditionalTile
      anchorProps={{
        id: 'TradeinTile',
        'data-analytics-id': 'Conditional Tile',
        'data-native-included': !isEligible,
        'data-native-payload': isEligible
          ? undefined
          : JSON.stringify({ action: NavPayloadAction.ViewTrades }),
        'data-analytics-attributes': JSON.stringify({
          action: 'clicked',
          tile: 'TradeinTile',
          position
        }),
        href: SELL_MY_CAR_URL,
        onClick: handleTradeCtaClick
      }}
      ctaCopy={shouldUseTitleCasing ? 'Get Your Offer' : 'Get your offer'}
      description="Get a real offer in less than 2 minutes. Sell, trade or track your value."
      imageProps={{
        src: `${appAssetsCdnUrl}/images/heliosConditionalTiles/trade-illustration.png`,
        alt: 'TradeIn'
      }}
      position={position}
      tileName="TradeinTile"
      title="Trade in your car"
    />
  );
}
